import { render, staticRenderFns } from "./sucess.vue?vue&type=template&id=fe7fe2ba&scoped=true"
import script from "./sucess.vue?vue&type=script&lang=ts"
export * from "./sucess.vue?vue&type=script&lang=ts"
import style0 from "./sucess.vue?vue&type=style&index=0&id=fe7fe2ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7fe2ba",
  null
  
)

export default component.exports